import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, sub, align = "left", testid }) {
  return (
    <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-blue-400 mb-4">{eyebrow}</p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-50 leading-[1.05]" data-testid={testid}>
        {title}
      </h2>
      {sub && <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>}
    </Reveal>
  );
}
